import Base from './base.js';
import { noop, setDeviceId, getXPath } from './utils/utils.js';
import { getOsName, getWebPlatform, detectOS, getAppKeyToWeb } from './utils/ua.js';

import Reduction from './reduction';
import localStorage from './utils/localStorage';
import { addListener, destroy } from './utils/catchError';
import { ERROR_TYPES } from './utils/constant.js';

const DEFAULT_OPTIONS = {
  _autoRecordBehavior: false,
  _autoRecordError: true,
  _samplingRate: 0.1, // 0-100的设置，可以是小数点
};

class Monitor extends Base {
  constructor(props) {
    super(props);
  }

  init(info) {
    if (!info.projectId) {
      console.log('Monitor init error: projectId is required');
      return false;
    }
    const data = { ...DEFAULT_OPTIONS, ...info };
    this._isInit = true;
    this._projectConfig = data;
    this._collectBaseInfo();
  }

  setScene(scene) {
     this._setScene(scene, window.location.href);
  }

  // 基础信息收集
  async _collectBaseInfo() {
    const { device } = getOsName();
    const osInfo = detectOS();
    const platform = getWebPlatform();
    const appVersion = '12.11';
    const deviceId = await this._getDeviceId();
    const appKey = getAppKeyToWeb();
    this._collectionInfo = {
      os: osInfo.type,
      osVersion: osInfo.version,
      appVersion,
      platform,
      model: device,
      deviceId,
      appKey,
      userAgent: window.navigator.userAgent,
      url: window.location.href,
      tags: '[]',
    };
  }

  async _getDeviceId() {
    let deviceId = await localStorage.getItem('deviceId');
    if (!deviceId) {
      deviceId = setDeviceId();
      localStorage.setItem('deviceId', 'xmdevice_' + deviceId);
    }
    return deviceId;
  }

  // 错误收集
  _initCatchError() {
    if (!this._projectConfig._autoRecordError) {
      return;
    }
    addListener((error) => {
      // 处理jsError
      if ([ERROR_TYPES.JAVASCRIPT, ERROR_TYPES.PROMISE].includes(error.type)) {
        this.recordErrorEvent({
          name: error.message,
          tags: {
            subType: error.type,
          },
          info: {
            ...error,
          },
        });
        // 处理resourceFailed
      } else if (error.type === ERROR_TYPES.RESOURCE) {
        this.recordResourceFailedEvent({
          name: error.message,
          tags: {
            subType: error.subType,
              url: error.url,
          },
          info: {
            ...error,
          },
        });
      }
    });
  }

   _initReduction(debugId, host) {
    if (!debugId || !host) { return; }
    this._reductionInstance = new Reduction({ debugId, host });
    this._reductionInstance.init();
  }

  // 行为自动化收集器
  _initBehaviorRecord() {
    // 如果没有开启自动化记录，则直接返回
    if (!this._projectConfig._autoRecordBehavior) {
      return;
    }
    // 初始化监听
    this._autoRecordTouch();
    this._autoRecordScroll();
  }

  _autoRecordTouchEventHandler(event) {
    const xpath = getXPath(event.target);
    this.recordTouchEvent({
      name: '点击行为',
      info: {
        isXpath: true,
        tag: xpath,
      },
    }, true);
  }

  _autoRecordTouch() {
    this._autoRecordTouchEventHandler = this._autoRecordTouchEventHandler.bind(this);
    document.addEventListener('click', this._autoRecordTouchEventHandler, true);
  }

  _autoRecordScrollEventHandler = noop

  _autoRecordScroll() {
    const scrollTimeouts = new Map();
      let xPath = null;
      let isScrolling = false;
      let timestamp = null;
      this._autoRecordScrollEventHandler = (event) => {
        const scrollElement = event.target.nodeType === 9 ? event.target.documentElement : event.target;
          if (scrollElement === document || scrollElement.scrollHeight <= scrollElement.clientHeight) {
            return;
          }
          if (!xPath && !isScrolling) {
            // 记录滚动开始时间戳和元素的 XPath
            isScrolling = true;
            xPath = getXPath(scrollElement);
            timestamp = Date.now();
          }
          const timeoutId = scrollTimeouts.get(scrollElement);
          if (timeoutId) {
            clearTimeout(timeoutId);
          }

          const newTimeoutId = setTimeout(() => {
            console.log(xPath, '>>>>>_autoRecordScrollEventHandler');
            this.recordScrollEvent({
              name: '滚动行为',
              time: timestamp, // 开始滚动的时间戳
              info: {
                isXpath: true,
                tag: xPath,
                offsetY: scrollElement.scrollTop,
                offsetX: scrollElement.scrollLeft,
                duration: Date.now() - timestamp,
              },
            }, true);
            console.log('记录滚动:');
            xPath = null;
            isScrolling = false;
            timestamp = null;
            scrollTimeouts.delete(scrollElement);
          }, 150);
          scrollTimeouts.set(scrollElement, newTimeoutId);
      };
      // 使用事件委托监听所有滚动事件
      document.addEventListener(
        'scroll',
        this._autoRecordScrollEventHandler,
        {
          capture: true,
          passive: true,
        },
      );
  }

  _removeBehaviorRecord() {
    document.addEventListener('click', this._autoRecordTouchEventHandler, true);
    document.removeEventListener(
      'scroll',
      this._autoRecordScrollEventHandler,
      {
        capture: true,
        passive: true,
      },
    );
    this._autoRecordScrollEventHandler = noop;
  }

  _afterSendDataHook() {
    if (this._projectConfig._autoRecordBehavior) {
      this._removeBehaviorRecord();
    }
    if (this._projectConfig._autoRecordError) {
      destroy();
    }
  }
}

let instance = null;
class MonitorSingleton {
  static getInstance(props) {
    if (!instance) {
      instance = new Monitor(props);
      // Object.freeze(instance);
    }
    return instance;
  }
}

export default MonitorSingleton.getInstance();

export {
  ERROR_TYPES,
};
